/**
 * Print menu for WM > Location Tracking > Adjust Available Unavailable Status (Delphi WMD0051).
 *
 * How the Delphi menu is built (uAbNav.pas DoPrint, lines 967-1167):
 *  - It walks the form's components collecting every TAbReportObject whose ShowOnMenu is True, so the
 *    order is DFM declaration order — never alphabetical.
 *  - The caption is NOT a property of the report object. It comes from a global registry populated by
 *    ab_RegisterReport(<dataModule>, <class>, <report name>) in each report unit's initialization
 *    section, keyed by the object's DataModule name. The names below are those exact strings.
 *  - A report declared with OpenReportConfig = True is prefixed with '* ', which is the only cue that
 *    clicking opens the shared report-configuration form (frmABD0010) instead of printing immediately.
 *    All three WMD0051 reports set OpenReportConfig = True.
 *  - A separator is appended after the reports, then a final 'Refresh Report List' item which re-reads
 *    the report FORMAT list from ABREPORTFORMATS (it does not change the top-level list, which is
 *    compile-time) and does not reopen the menu.
 *  - The popup is anchored to the bottom-left corner of the Print button. No icons are used.
 *  - There is no permission filtering when the menu is built; access is checked after clicking.
 *
 * Not replicated (deliberate): per-report format submenus, which Delphi builds only when a report has
 * more than one registered format. There is nothing to enumerate until the reports themselves exist.
 *
 * The reports are not migrated yet, so every entry reports "under construction" for now.
 */
const AdjustAvailableUnAvailableReportMenuItems = [
    {
        text: "* Adjust Available/Unavailable Status Report",
        dataModule: "frmWMR0055",
    },
    {
        text: "* Item Availability With Unavailable Reason",
        dataModule: "frmWMR0071",
    },
    {
        text: "* Item/Location Availability With Unavailable Reason Report",
        dataModule: "frmWMR0072",
    },
    {
        // beginGroup draws the separator the Delphi menu puts between the reports and this item.
        text: "Refresh Report List",
        beginGroup: true,
        isRefresh: true,
    },
];

export default AdjustAvailableUnAvailableReportMenuItems;
